import React, { useEffect, useRef } from "react";
import { Grid, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Role from "../../actions/role";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
import Layout from "../layout/Layout";
import Admin from "../auth/Admin";
import CheckboxGroup from "../controls/CheckBox";
import { permissions } from "../../utils/utils";
import Notify from "../customHelpers/Notify";
import Notification from "../customHelpers/Notification";

const initialFValues = {
  name: "",
  description: "",
  permissions: [], // Initialize as an empty array
  editing: false,
};

const AddRole = ({
  setOpenPopup,
  recordForEdit,
  setRoles,
  edite,
  getAllRoles,
}) => {
  useEffect(() => {
    if (recordForEdit != null && edite) {
      const existingPermissions = recordForEdit.rolePermissions
        ? recordForEdit.rolePermissions.map((perm) => perm.action)
        : [];

      setValues({
        ...recordForEdit,
        permissions: existingPermissions, // Set the permissions to the existing ones
      });
    }
  }, [recordForEdit]);

  const { addRole, updateRole } = Role();
  const { NotifyMessage, notify, setNotify } = Notify();

  const validate = (fieldValues = values) => {
    const temp = { ...errors };
    if ("name" in fieldValues)
      temp.name =
        fieldValues.name.length !== 0 ? "" : "This field is required.";

    setErrors({
      ...temp,
    });
    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };
 const firstFieldRef = useRef(null);
  useEffect(() => {
    if (firstFieldRef.current) {
      firstFieldRef.current.focus();
    }
  }, []);
  const { values, errors, setValues, handleInputChange, setErrors, resetForm } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setValues({ ...values, submitting: true });
      if (!edite) {
        delete values.logginError;
        delete values.editing;
        addRole(values).then((data) => {
          if (data.err) {
            setValues({ ...values, submitting: false });
            NotifyMessage({
              message: data.err,
              type: "error",
            });
          } else if (data.role) {
            history.push("/roles");
          }
        });
      } else {
        delete values.logginError;
        delete values.editing;
        updateRole(values, values.id).then((data) => {
          if (data.err) {
            setValues({ ...values, submitting: false });
            NotifyMessage({
              message: data.err,
              type: "error",
            });
          } else {
            NotifyMessage({
              message: "Role successfully updated",
              type: "success",
            });
            setOpenPopup(false);
            resetForm();
            getAllRoles();
          }
        });
      }
    }
  };

  const handlePermissionChange = (event) => {
    const { name, checked } = event.target;

    let updatedPermissions = Array.isArray(values.permissions)
      ? [...values.permissions]
      : [];

    if (checked) {
      updatedPermissions.push(name);
    } else {
      updatedPermissions = updatedPermissions.filter((perm) => perm !== name);
    }

    setValues({ ...values, permissions: updatedPermissions });
  };

  const permissionOptions = permissions().map((perm) => ({
    label: perm.label,
    value: perm.value,
    group: perm.group,
  }));

  const history = useHistory();

  // Group permissions by their group property
  const groupedPermissions = permissionOptions.reduce((acc, permission) => {
    const group = permission.group || "Other";
    if (!acc[group]) {
      acc[group] = [];
    }
    acc[group].push(permission);
    return acc;
  }, {});

  const handleCheckAll = () => {
    const allPermissions = permissionOptions.map((perm) => perm.value);
    setValues({ ...values, permissions: allPermissions });
  };

  const handleUncheckAll = () => {
    setValues({ ...values, permissions: [] });
  };

  return (
    <Layout>
      <Admin>
        <Typography variant="h6" className="page-header">
          <ArrowBackIcon
            style={{ cursor: "pointer" }}
            onClick={() => {
              history.push("/roles");
            }}
          />
          <span style={{ marginLeft: "6px" }}>Role Add Page</span>
        </Typography>
        <div style={{ marginBottom: "5px" }}>
          <Controls.Button
            text="Check All"
            variant="contained"
            size="small"
            className="Button"
            onClick={handleCheckAll}
          />
          <Controls.Button
            text="Uncheck All"
            variant="contained"
            size="small"
            className="Button"
            onClick={handleUncheckAll}
            style={{ marginLeft: "8px" }}
          />
        </div>
        <Form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Controls.Input
                name="name"
                label="Name"
                value={values.name}
                onChange={handleInputChange}
                error={errors.name}
                inputRef={firstFieldRef}

              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Controls.Input
                name="description"
                label="Description"
                value={values.description}
                onChange={handleInputChange}
                error={errors.description}
              />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {Object.keys(groupedPermissions).map((groupName) => (
                  <Grid
                    item
                    xs={12}
                    md={
                      groupName === "Inventory" ||
                      groupName === "Report" ||
                      groupName === "Categories" ||
                      groupName === "Customer"
                        ? 3
                        : 2
                    }
                    key={groupName}
                  >
                    <CheckboxGroup
                      name="permissions"
                      label={groupName}
                      options={groupedPermissions[groupName]}
                      value={values.permissions}
                      onChange={handlePermissionChange}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <div>
                <Controls.Button
                  disabled={values.submitting ? true : false}
                  text={
                    edite === true
                      ? values.submitting
                        ? "Editing..."
                        : "Done"
                      : values.submitting
                      ? "Adding..."
                      : "Add"
                  }
                  variant="contained"
                  className="Button"
                  type="submit"
                />
                <Controls.Button
                  text="Cancel"
                  variant="contained"
                  className="Button"
                  onClick={() => {
                    history.push("/roles");
                  }}
                />
              </div>
            </Grid>
          </Grid>
        </Form>
        <Notification notify={notify} setNotify={setNotify} />
      </Admin>
    </Layout>
  );
};

export default AddRole;
